export const startCheckout = async (payload) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    try {
        const response = await fetch('/api/checkout-start.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ ...payload, website: '' }),
            signal: controller.signal
        });
        if (!response.ok)
            throw new Error(`Acceptance delivery failed (${response.status})`);
        const result = (await response.json());
        if (!result.checkoutUrl || !result.sessionId)
            throw new Error('Invalid checkout response');
        return { checkoutUrl: result.checkoutUrl, sessionId: result.sessionId };
    }
    finally {
        window.clearTimeout(timeout);
    }
};
export const getCheckoutStatus = async (sessionId) => {
    const response = await fetch(`/api/checkout-status.php?session_id=${encodeURIComponent(sessionId)}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok)
        throw new Error(`Checkout status failed (${response.status})`);
    return (await response.json());
};
